import React, { useState, useContext, useEffect, } from 'react'

import backButton from "../../../Image/backButton.svg"
import dreamstars_logo from "../../../Image/dreamstars_logo.png"
import { Link } from 'react-router-dom'
import { Notification, SelectPicker, useToaster, Uploader, Message, Loader } from 'rsuite';
import { Auth } from '../../../Contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import customValidation from '../../../Helpers/customValidation';
import ErrorHelper from '../../../Helpers/ErrorHelper'
import CustomLoader from '../../comman/Loader/CustomLoader';
import { FaCommentsDollar } from 'react-icons/fa'
import Footer from '../../comman/Footer'
import Select from 'react-select';
import colourStyles from '../../../Helpers/colourStyles';




const BrandJoin = () => {
    const [stphone, setStphone] = useState();
    const data = ['Yes', 'No'].map(
        item => ({ label: item, value: item }));

    const toaster = useToaster();
    const navigate = useNavigate();
    const [showBrandDetail, setShowBrandDetail] = useState(false)
    const [validataionErrors, setValidataionErrors] = useState([]);
    const { formData, setFormData } = useContext(Auth);
    const [countries, setCountries] = useState([]);
    const [fileInfo, setFileInfo] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getCountries();
    }, [])


    const getCountries = () => {
        let config = {
            url: ApiUrl.countries,
            method: 'GET',
            body: {},
        };

        APIRequest(
            config,

            res => {
                setCountries(res.data)

            },
            err => {

            },
        );
    }

    const changeInput = (e) => {
        const name = e.target.name;

        if (name === 'phone') {

            if (!customValidation.isPositveIntegerNumber(e?.target?.value)) {
                return false;
            }
        } else if (name === 'owner_name') {
            if (!customValidation.isAlphabet(e?.target?.value)) {
                return false;
            }

        }

        let value;
        if (name === 'tos') {
            value = e.target.checked;
        } else {
            value = e.target.value;
        }

        const collect = {
            ...formData,
            [name]: value,


        };

        const IsError = validataionErrors?.find(v => v.field === name);

        if (IsError !== undefined) {
            const errors = validataionErrors?.filter(v => v.field !== name);
            setValidataionErrors(errors);
        }

        setFormData(collect);
    }

    const handleOnChange = (value) => {
        const collect = {
            ...formData,
            'country_id': value,

        };
        const IsError = validataionErrors?.find(v => v.field === 'country_id');


        if (IsError !== undefined) {
            const errors = validataionErrors?.filter(v => v.field !== 'country_id');
            setValidataionErrors(errors);
        }


        setFormData(collect);


    }

    const sources = ["Social Media", "Press Coverage", "A Content Creater", "Another Brand", "Search Engine"];

    const handleBack = () => {
        if (showBrandDetail) {
            setShowBrandDetail(false)
        } else {
            navigate("/join-dreamstar")
        }
    }

    const handleOnKnownSource = (val) => {
        const collect = {
            ...formData,
            'found_us_via': val,

        };
        setFormData(collect);
    }

    const handleAvatarUpload = (value) => {
        const collect = {
            ...formData,
            avatar: value

        };
        setFormData(collect);

    }

    const onRemoveFile = () => {

    }

    function previewFile(file, callback) {
        const reader = new FileReader();
        reader.onloadend = () => {
            callback(reader.result);
        };
        reader.readAsDataURL(file);
    }


    const handleBrandDetail = (e) => {
        e.preventDefault();
        e.target.reset();

        let config = {
            url: ApiUrl.validateBrandInfo,
            method: 'POST',
            body: {
                email: formData?.email,
                password: formData?.password,
                brand_name: formData?.brand_name,
                website: formData?.website,
                country_id: formData?.country_id.value,
                vat_no: formData?.vat_no,
                avatar: formData?.avatar
            }

        }

        APIRequest(
            config,
            res => {

                setShowBrandDetail(res.status);

            },

            err => {
                if (err.response.status === 422) {

                    setValidataionErrors(err?.response?.data?.errors);

                } else {
                    alert(err?.message)
                }
            })

    }



    const brandDetail = () => {
        return (
            <>
                <form onSubmit={handleBrandDetail} className='mt-7 text-[16px] mb-14 flex flex-col flex-wrap items-center w-[300px] sm:w-[440px] lg:w-[480px] font-museob  ' >

                    <div className='w-full ' >
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} className="border-none outline-none rounded-lg w-full h-[47px] placeholder:text-slate-300" value={formData?.email !== undefined ? formData?.email : ''} type="email" name="email" id="email" placeholder="Email Address"  ></input>
                        {ErrorHelper(validataionErrors, "email")}

                    </div>


                    <div className='w-full my-3' >
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} className="border-none outline-none rounded-lg w-full h-[47px] placeholder:text-slate-300" value={formData?.password !== undefined ? formData?.password : ''} type="password" name="password" id="password" placeholder="Password" ></input>
                        {ErrorHelper(validataionErrors, "password")}
                    </div>

                    <div className='w-full' >
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} type="text" value={formData?.brand_name !== undefined ? formData?.brand_name : ''} name="brand_name" id="brand_name" placeholder="Brand/company name"
                            className="border-none outline-none rounded-lg w-full h-[47px]   placeholder:text-slate-300 " ></input>

                        {ErrorHelper(validataionErrors, "brand_name")}
                    </div>

                    <div className='w-full my-3 ' >


                        <Select
                            className="joinClass sbar"
                            classNamePrefix="joinChild sbar"
                            placeholder="Country"
                            styles={colourStyles}
                            isClearable={true}
                            // defaultValue={formData?.country_id !== undefined ? formData?.country_id : ''}
                            value={formData?.country_id !== undefined ? formData?.country_id : ''}
                            onChange={(value) => handleOnChange(value)}
                            options={countries?.map(item => ({ label: item?.name, value: item?.id }))}

                        />

                        {ErrorHelper(validataionErrors, "country_id")}
                    </div>

                    <div className='w-full'>
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} value={formData?.website !== undefined ? formData?.website : ''} name="website" id="website" type="text" placeholder="Website"
                            className="border-none outline-none rounded-lg w-full h-[47px]   placeholder:text-slate-300" ></input>

                        {ErrorHelper(validataionErrors, "website")}
                    </div>

                    <div className='w-full my-3 z-0 ' >

                        <Select
                            className="joinClass"
                            classNamePrefix="joinChild sbar "
                            placeholder="Do you have ST Number"
                            isClearable={true}
                            options={data}
                            styles={colourStyles}
                            onChange={(value) => { setStphone(value) }}
                            // defaultInputValue={stphone !== undefined ? stphone : ''}
                            value={stphone !== undefined ? stphone : ''}
                           
                        />
                        {ErrorHelper(validataionErrors, "vat_no")}
                    </div>
                    {console.log("stPhone : " , stphone)}
                    {stphone?.value === "Yes" ? (
                        <div className='w-full mb-3 '>
                            <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                                onChange={changeInput} name="vat_no" id="vat_no" type="text" value={formData?.vat_no !== undefined ? formData?.vat_no : ''} placeholder="type a ST number"
                                className="border-none outline-none rounded-lg w-full  h-[47px]   placeholder:text-slate-300"></input>

                        </div>) : null}

                    <Uploader
                        listType="picture-text"
                        fileListVisible={false}
                        multiple={false}
                        data={{ folder: "brand" }}
                        method={'POST'}
                        action={ApiUrl.uploadLogo}
                        onRemove={(file) => { onRemoveFile(file) }}
                        onSuccess={(response, file) => {
                            handleAvatarUpload(response?.file)

                            setUploading(false);
                            toaster.push(<Message type="success" header="Success">Uploaded successfully</Message>);
                        }}
                        onError={() => {
                            setFileInfo(null);
                            setUploading(false);
                            toaster.push(<Message type="error" header="Error">Upload failed</Message>);
                        }}

                        onUpload={file => {
                            setUploading(true);
                            previewFile(file.blobFile, value => {
                                setFileInfo(value);
                            });
                        }}


                        draggable style={{ width: "100%", marginTop: "6px" }}
                    >


                        <div style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px', width: "100%", borderStyle: 'none', maxHeight: "100%", borderRadius: "8px" }}  >
                            {uploading && <Loader backdrop center />}
                            {fileInfo ? (
                                <img src={fileInfo} alt="file_img" style={{ maxHeight: "80px", objectFit: "contain", objectPosition: "0,100%" }} />
                            ) : (
                                <div style={{ borderRadius: '8px', height: 110, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', borderStyle: 'none' }}>
                                    <div className=" max-w-full flex flex-col justify-center items-center" >
                                        <p className='bg-slate-300 w-7 h-7 text-slate-800 text-center rounded-full flex justify-center items-center text-lg font-museob ' >+</p>
                                        <p className='font-museob text-slate-600' >Drag or upload your brand logo</p>
                                    </div>
                                </div>
                            )}

                        </div>

                    </Uploader>

                    <button style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                        className=' mt-[24px] btn-anim i bg-[#DB332A] px-[60px] sm:mb-10 py-[10px] rounded-lg  text-white font-museobb '>CONTINUE</button>
                </form>
            </>
        )
    }



    const handleSubmit = (e) => {
        e.preventDefault()
        let config = {
            url: ApiUrl.signUp,
            method: 'POST',
            body: {
                email: formData?.email,
                password: formData?.password,
                brand_name: formData?.brand_name,
                website: formData?.website,
                country_id: formData?.country_id.value,
                //   campaign_style: formData?.choice_radio,
                //   typical_budget: formData?.campaign_budget,
                vat_no: formData?.vat_no,
                owner_name: formData?.owner_name,
                job_title: formData?.job_title,
                phone: formData?.phone,
                found_us_via: formData?.found_us_via.value,
                tos: formData?.tos,
                avatar: formData?.avatar
            }
        }
        APIRequest(
            config,
            res => {
                toaster.push(<Notification type='success' header="Success"  >Profile created please login to continue..</Notification>, {
                    placement: 'topEnd'
                });
                setFormData(" ");
                navigate("/brand")



            },

            err => {
                if (err.response.status === 422) {
                    setValidataionErrors(err?.response?.data?.errors);

                } else {

                    alert(err?.message)
                }
            }

        )

    }

    const ownerDetail = () => {
        return (
            <>
                <CustomLoader visible={isLoading} />
                <form className='mt-7 mb-[60px]  flex flex-col items-center h-full justify-center  w-[300px] sm:w-[440px] lg:w-[480px] font-museob ' >
                    <div className='w-full ' >
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} value={formData?.owner_name !== undefined ? formData?.owner_name : ''} type="text" name="owner_name" id=" owner_name" placeholder='Full name'
                            className="border-none outline-none rounded-lg w-full h-[47px]   placeholder:text-slate-300"></input>

                        {ErrorHelper(validataionErrors, "owner_name")}
                    </div>

                    <div className='w-full my-3 '>
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} value={formData?.job_title !== undefined ? formData?.job_title : ''} name="job_title" id="job_title" type="text" placeholder="Job title"
                            className="border-none outline-none rounded-lg w-full  h-[47px]   placeholder:text-slate-300"></input>

                    </div>

                    <div className='w-full'>
                        <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                            onChange={changeInput} required value={formData?.phone !== undefined ? formData?.phone : ''} name="phone" id="phone" type="text" placeholder="Phone number"
                            className="border-none outline-none rounded-lg w-full  h-[47px]   placeholder:text-slate-300"  ></input>
                        {ErrorHelper(validataionErrors, "phone")}
                    </div>

                    <div className='w-full mt-3 rounded-lg ' >


                        <Select
                            className="joinClass sbar"
                            classNamePrefix="joinChild sbar"
                            placeholder="How did you hear about us ?"
                            styles={colourStyles}
                            isClearable={true}
                            // defaultValue={formData?.found_us_via !== undefined ? formData?.found_us_via : ''}
                            value={formData?.found_us_via !== undefined ? formData?.found_us_via : ''}
                            onChange={(value) => handleOnKnownSource(value)}
                            options={sources?.map(item => ({ label: item, value: item }))}

                        />

                    </div>

                    <button onClick={handleSubmit} type="submit" id='submit'
                        style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
                        className='mt-[30px] btn-anim i bg-[#DB332A] px-[60px] py-[10px] rounded-lg  text-white font-museobb '>SUBMIT</button>

                    <div className='mt-5' >
                        <div className='flex justify-center items-center  ' >
                            <input onChange={changeInput} value={formData?.tos} type="checkbox" checked={formData?.tos !== undefined ? formData?.tos : false} id="tos" name="tos"
                                className='rounded-full border-none outline-none mr-3 cursor-pointer w-5 h-5 ' />
                            <p className=' text-white text-xs textShad '><label htmlFor="tos">I have read and agree to the <Link to="/terms" className='text-white underline hover:text-white' > Terms & conditons</Link></label>

                            </p>

                        </div>
                        <div className='ml-8' >{ErrorHelper(validataionErrors, "tos")}</div>
                    </div>
                </form>
            </>
        )
    }



    return (
        <>
            <div className='brandJoinM relative max-w-screen min-h-screen font-museo bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center '>
                <img onClick={handleBack} alt="back_btn" src={backButton} className=" cursor-pointer absolute top-5 left-8" />
              
                <div className=' font-museob flex flex-col items-center justify-center md:mt-14 mt-20 ' >
                    <p className='font-museob text-white text-4xl relative -bottom-5 ' >Join</p>
                    <img src={dreamstars_logo} alt="web_logo" className="w-[50%]  ml-8 my-2 " ></img>
                    <p className='text-white text-4xl ' >I'm a <span className='font-museobb' >Brand</span></p>
                </div>

                {showBrandDetail ? ownerDetail() : brandDetail()}

                <div className='absolute bottom-0' ><Footer colorClass="footerColor2" clas="footer" /></div>

            </div>



        </>
    )
}

export default BrandJoin
